import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { InputHLPure, TextAreaHLPure, ButtonHLPure, LabelModalPure } from "../../pures";
import { Grid, useMediaQuery } from "@material-ui/core";
import { Dialog } from "@progress/kendo-react-dialogs";

import "./sign-request-by-volume-description-view.css";

const SignRequestByVolumeDescriptionView = (props) => {
  const { t } = useTranslation();
  const { step, onHandleBack } = props;
  const { next, back } = step;
  const [showDialog, setShowDialog] = useState(false);

  const toggleDialog = () => setShowDialog(!showDialog);

  const onHandleSubmit = () => {
    props.onValidateProfileData();
  };

  const isMobile = useMediaQuery("(max-width:560px)")

  return (
    <div className="step-card-signatureRequestProfileData">
      <Grid container lg={12} md={12} sm={12} xs={12}>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="form-item-signatureRequestProfileData"
        >
          <InputHLPure
            labelInput={t("signatureRequestView2.toolTipFirst")}
            typeInput={"text"}
            valueInput={props.requestName}
            handleChangeInput={(e) => props.onChangeNameSignature(e)}
            errorInput={props.errorMessageCurrentNameSignature}
            errorInputText={t('signatureRequestProfileData.nameSignature')}
            informationIcon
            tooltipShow
            positionTooltip={isMobile ? "top" : "right"}
            titleTooltip={t("signatureRequestView2.toolTipFirst")}
            descriptionTooltip={t("signatureRequestView2.tooltipFirstDetail")}
            inputActive
          />
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="form-item-signatureRequestProfileData"
        >
          <TextAreaHLPure
            labelTextArea={t("signatureRequestView2.addComments")}
            valueTextData={props.comments || ""}
            handleChangeTextArea={(e) => props.onChangeComments(e)}
            errorInput={props.errorMessageCurrentComments}
            errorTextArea={t('signatureRequestProfileData.notes')}
            tooltipShow
            informationIcon
            positionTooltip={isMobile ? "top" : "right"}
            titleTooltip={t("signatureRequestView2.addComments")}
            descriptionTooltip={t("signatureRequestView2.tooltipCommentsDescription")}
          />
        </Grid>
      </Grid>
      <div className="action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={toggleDialog}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onHandleSubmit}
        />
      </div>
      {showDialog && (
        <Dialog
          className="modal-exit"
          title={t("signRequestByVolume.modalTitle")}
          onClose={toggleDialog}
        >
          <div className="exit-content">
            <div className="label-exit">
              <LabelModalPure label={t("signRequestByVolume.modalExit")}/>
            </div>
            <div className="signRequestByVolume-buttons-exit">
              <ButtonHLPure
                nameBtn={t("signRequestByVolume.exit")}
                primary={false}
                onClickBtn={(event) => onHandleBack(event)}
              />
              <ButtonHLPure
                nameBtn={t("signRequestByVolume.continueProcess")}
                primary={true}
                onClickBtn={(event) => toggleDialog(event)}
              />
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default SignRequestByVolumeDescriptionView;
